import { Outlet } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import yantraGanapati from '@/assets/images/yantraGanapati.jpg';
import background1 from '@/assets/images/background1.svg';

/**
 * Main Layout Component
 * Used for public pages with header and footer
 */
const MainLayout = () => {
  return (
    <div 
      className="flex min-h-screen flex-col relative" 
    >
      

      {/* Content Layer */}
      <div className="relative z-10 flex min-h-screen flex-col flex-1">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
